import { DOC_SOURCE } from "constants/documents";
import { DOC_TYPE } from "layout/documentUploader/constants";
import { has, omit, pick, values } from "lodash";

export const FileFormat = {
  PDF: "PDF",
  WORD: "WORD",
  EXCEL: "EXCEL",
  POWERPOINT: "POWERPOINT",
  RTF: "RTF",
  OTHER: "OTHER",
};

export const ANALYSIS_DISABLED_FORMATS = [FileFormat.EXCEL, FileFormat.OTHER];

export const ANALYSIS_HIDDEN_FORMATS = [FileFormat.POWERPOINT];

export const ANALYSIS_SUPPORTED_FORMATS = values(
  omit(FileFormat, [...ANALYSIS_DISABLED_FORMATS, ...ANALYSIS_HIDDEN_FORMATS])
);

export const getFileExtension = (fileName) => {
  if (typeof fileName !== "string" || !fileName.trim()) {
    return "";
  }

  const cleanName = fileName.replace(/\?.*$/, ""); // NOSONAR javascript:S5852 - \? is a mandatory literal anchor before .* — inputs without ? fail in O(1) per position; inputs with ? match in a single greedy pass with no backtracking.
  const [ext] = cleanName.toLowerCase().split(".").reverse();

  return ext;
};

export const getFileFormat = (fileName) => {
  const ext = getFileExtension(fileName);

  if (!ext) {
    return FileFormat.OTHER;
  }

  switch (ext) {
    case "pdf":
      return FileFormat.PDF;
    case "doc":
    case "docx":
    case "docm":
      return FileFormat.WORD;
    case "xls":
    case "xlsx":
    case "xlsm":
      return FileFormat.EXCEL;
    case "pptx":
    case "pptm":
      return FileFormat.POWERPOINT;
    case "rtf":
      return FileFormat.RTF;
    default:
      return FileFormat.OTHER;
  }
};

export const isSupportedFormat = (
  doc,
  { includeEditorDocuments = false, supportedFormats = values(FileFormat) } = {}
) => {
  if (!doc?.name) {
    return false;
  }

  const format = getFileFormat(doc?.name);
  const fileFormats = pick(FileFormat, supportedFormats);
  const isFormatSupported = has(fileFormats, format);

  if (!includeEditorDocuments) {
    return isFormatSupported;
  }

  return (
    isFormatSupported ||
    doc.source === DOC_SOURCE.VT_EDITOR ||
    (doc.source === DOC_SOURCE.ADDIN && doc.type === DOC_TYPE.RESEARCH)
  );
};

export const withoutAnalysisHiddenFormats = (documents = []) =>
  documents.filter(
    (doc) => !ANALYSIS_HIDDEN_FORMATS.includes(getFileFormat(doc?.name))
  );
